$(document).on('turbolinks:load', function() {
  if (!$('body').hasClass('controller-leagues-one_day_events')) return;

  function toggleGroupsMode() {
    $('.groups-mode-container').remove();
    const selectedFormatOption = $('.event-format-option input[type="radio"]:checked');
    selectedFormatOption.closest('.event-format-option').append($('#groups-mode-template').html());
  }

  function updateSideSelect() {
    const selectedHoles = $('input[name="one_day_event[number_of_holes]"]:checked').val();
    const container = $('#side-select-container');

    const existingSelect = container.find('.side-select');
    if (existingSelect.length && existingSelect.hasClass('select2-hidden-accessible')) {
      existingSelect.select2('destroy');
    }

    container.empty();

    if (selectedHoles === '9') {
      container.html($('#nine-hole-sides-template').html());
    } else if (selectedHoles === '18') {
      container.html($('#eighteen-hole-sides-template').html());
    }

    container.find('.side-select').select2();
  }

  function reloadPageWithCourse() {
    const homeCourseId = $('.home-course-select').val();
    if (homeCourseId) {
      window.location.href = window.location.pathname + '?home_course_id=' + homeCourseId;
    }
  }

  toggleGroupsMode();
  updateSideSelect();

  $('.home-course-select').on('change', function() {
    reloadPageWithCourse();
  });

  $('.event-format-option input[type="radio"]').on('change', function() {
    toggleGroupsMode();
  });

  $('input[name="one_day_event[number_of_holes]"]').on('change', function() {
    updateSideSelect();
  });

  $('#one_day_event_event_date').mask('00/00/0000').pickadate();
});

